import { Pagination } from '@/domain/entities/Pagination'

export class NotificationData {
  public id: number
  public ownerId: number
  public ownerType: string
  public title: string
  public content: string
  public deletable: boolean
  public createdAt: string
  public updatedAt: string
  public attachment: string

  constructor(
    id: number,
    ownerId: number,
    ownerType: string,
    title: string,
    content: string,
    deletable: boolean,
    createdAt: string,
    updatedAt: string,
    attachment: string
  ) {
    this.id = id
    this.ownerId = ownerId
    this.ownerType = ownerType
    this.title = title
    this.content = content
    this.deletable = deletable
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.attachment = attachment
  }
}

export class Notification {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: NotificationData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: NotificationData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
